import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { ReportedOwnersList } from 'src/v2/views/owner-reveal/insights/parcel-insights/reported-owners/reported-owners/list'

export const ReportedOwnersWidget: FC = () => {
  return (
    <WidgetCard
      id="reported-owners"
      title="Reported Owners"
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <ReportedOwnersList />,
        },
      ]}
    />
  )
}
